"use strict";
exports.__esModule = true;
exports.chart_tooltip_Padding = {
  "name": "--pf-chart-tooltip--Padding",
  "value": 8,
  "var": "var(--pf-chart-tooltip--Padding, 8)"
};
exports["default"] = exports.chart_tooltip_Padding;